import { Platform } from 'react-native';

/**
 * El mail de Supabase aterriza con hash/PKCE y @supabase/supabase-js persiste una sesión válida
 * aunque el usuario no ponga nueva clave. Guardamos en localStorage (solo web) el user id del
 * flujo "recovery" abierto; si luego aterriza en otra ruta con esa sesión, cerramos sesión
 * (no alcanzó a completar o cerró el navegador).
 */
const KEY = 'vuelto_pw_recovery_user_id';

function canUseLocalStorage(): boolean {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return false;
  try {
    return typeof window.localStorage !== 'undefined';
  } catch {
    return false;
  }
}

export function markPasswordRecoveryFlowStarted(userId: string): void {
  if (!canUseLocalStorage()) return;
  try {
    window.localStorage.setItem(KEY, userId);
  } catch {
    /* private mode, etc. */
  }
}

export function clearPasswordRecoveryFlowMarker(): void {
  if (!canUseLocalStorage()) return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function getPasswordRecoveryFlowUserId(): string | null {
  if (!canUseLocalStorage()) return null;
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}
